import { PaginatedListPage } from './paginated-list-page'

export class PaginatedList<Type, AdditionalMeta = undefined> {
  pages: PaginatedListPage[]

  constructor(
    public results: Type[],
    public total: number,
    public limit: number,
    public current: number,
    public additional?: AdditionalMeta
  ) {
    this.pages = this.total
      ? [...Array(Math.ceil(this.total / this.limit)).keys()].map(
          (i) => new PaginatedListPage(i + 1, i + 1 === this.current)
        )
      : []
  }

  static fromResults<Type, AdditionalMeta = undefined>(
    results: Type[],
    additional?: AdditionalMeta
  ): PaginatedList<Type, AdditionalMeta> {
    return new PaginatedList(
      results,
      results.length,
      results.length,
      1,
      additional
    )
  }
}
